<div formGroupName="samplingCndt">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-panel-header-text">
            <mat-panel-title>検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>承認依頼年月日（開始）</mat-label>
                <input matInput [matDatepicker]="start" formControlName="apprvreqYearmonthdateStart" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                <mat-datepicker #start></mat-datepicker>
            </mat-form-field>
            <span style="margin-left: 40px;">～</span>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>承認依頼年月日（終了）</mat-label>
                <input matInput [matDatepicker]="end" formControlName="apprvreqYearmonthdateEnd" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[530px] tw-max-w-[530px] tw-min-w-[530px]">
                <mat-label>業務種別</mat-label>
                <input matInput style="display: none!important" value=" " formControlName="kinkoGyomuclsfyCodelst">
                <mat-selection-list formControlName="kinkoGyomuclsfyCodelst" class="tw-flex tw-flex-row tw-flex-wrap"
                    style="display: flex;">
                    <mat-list-option *ngFor="let status of gyomShubetuList;" [value]="status.value"
                        (selectedChange)="getControl('kinkoGyomuclsfyCodelst')?.markAsTouched()" class="mat-list-option"
                        color="primary" checkboxPosition="before">
                        {{status.viewValue}}
                    </mat-list-option>
                </mat-selection-list>
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[420px] tw-max-w-[420px] tw-min-w-[420px]">
                <mat-label>承認状況</mat-label>
                <input matInput style="display: none!important" value=" " formControlName="kinkoApprovalstatusCodelst">
                <mat-selection-list formControlName="kinkoApprovalstatusCodelst"
                    class="tw-flex tw-flex-row tw-flex-wrap" style="display: flex;">
                    <mat-list-option *ngFor="let status of approvalList;" [value]="status.value"
                        (selectedChange)="getControl('kinkoApprovalstatusCodelst')?.markAsTouched()"
                        class="mat-list-option" color="primary" checkboxPosition="before">
                        {{status.viewValue}}
                    </mat-list-option>
                </mat-selection-list>
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" class="btn"
                    [disabled]="searchConditionForm.invalid">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickClear()">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>